
import React from 'react';

interface Testimonial {
  name: string;
  location: string;
  text: string;
  stars?: number;
}

interface LocationTestimonialsProps {
  testimonials: Testimonial[];
  locationName: string;
  title?: string; // Added optional title prop
}

const LocationTestimonials = ({ testimonials, locationName, title }: LocationTestimonialsProps) => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-4">
            {title || `Hvad siger mine elever i ${locationName}`}
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Læs anmeldelser fra tidligere og nuværende klaverelever i {locationName}.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white p-8 rounded-lg shadow-md">
              <div className="flex flex-col h-full">
                <div className="mb-6">
                  <div className="flex text-piano-gold">
                    {[...Array(testimonial.stars || 5)].map((_, i) => (
                      <svg key={i} className="w-5 h-5 fill-current" viewBox="0 0 24 24">
                        <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                      </svg>
                    ))}
                  </div>
                </div>
                <blockquote className="text-gray-600 italic mb-6 flex-grow">
                  "{testimonial.text}"
                </blockquote>
                <footer className="mt-auto">
                  <p className="font-medium">{testimonial.name}</p>
                  <p className="text-sm text-gray-500">{testimonial.location}</p>
                </footer>
              </div>
            </div>
          ))}
        </div>
        
        <div className="text-center mt-12">
          <p className="text-gray-600">
            Læs flere anmeldelser på{" "}
            <a 
              href="https://dk.trustpilot.com/review/oscargilbert.dk" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-piano-gold font-medium"
            >
              Trustpilot
            </a>
          </p>
        </div>
      </div>
    </section>
  );
};

export default LocationTestimonials;
